import React from 'react';
import PropTypes from 'prop-types';

import { PATH } from '../../../constants/path';
import { STATIC_ROOT } from '../../../constants';

import { convertHtmlToReactDomWithParams, removeListMarker } from '../../../utils/htmlUtils';

import SvgComponent from '../../SvgComponent';
import LocalizedNavLink from '../../router/LocalizedNavLink';

import './FaqElementComponent.scss';

const isCurrentFaqHash = (hashId, currentId) => hashId && currentId && hashId === currentId;

class FaqElementComponent extends React.Component {
    constructor(props) {
        super(props);
        const { hashId, faq } = props;
        this.faqSection = React.createRef();
        this.state = { open: isCurrentFaqHash(hashId, faq.id) };
    }

    componentDidMount() {
        if (this.state.open) {
            this.faqSection.current.scrollIntoView({ behavior: 'smooth' });
        }
    }

    componentDidUpdate(prevProps) {
        const { hashId, faq } = this.props;

        if (hashId !== prevProps.hashId && isCurrentFaqHash(hashId, faq.id)) {
            this.setState({ open: true });
            this.faqSection.current.scrollIntoView({ behavior: 'smooth' });
        }
    }

    handleQuestionClick = () => this.setState({ open: !this.state.open });

    handleKeyDown = e => {
        if (e.key === 'Enter' || e.code === 'Space') {
            e.preventDefault();
            this.handleQuestionClick();
        }
    };

    renderSectionContents = () => {
        const {
            linkToFaqPage,
            faq,
            cssClass,
            forceArrowRight,
            noListMarker,
            isEbonFaq
        } = this.props;

        return (
            <div>
                <div
                    className={`${cssClass ? cssClass : 'question'} answer ${
                        this.state.open ? 'open' : ''
                    }`}
                    role="button"
                    onClick={this.handleQuestionClick}
                    tabIndex={linkToFaqPage ? '-1' : '0'}
                    onKeyDown={this.handleKeyDown}
                    aria-expanded={this.state.open ? 'true' : 'false'}>
                    {isEbonFaq ? faq.title : faq.question}
                    <SvgComponent
                        src={`${STATIC_ROOT}/fleche.svg`}
                        className={`${forceArrowRight ? '' : this.state.open ? 'haut' : 'bas'}`}
                        width="12"
                        height="21"
                        aria-hidden="true"
                        focusable="false"
                    />
                </div>
                <div
                    className={`${!this.state.open ? 'hide' : ''} answer ${
                        noListMarker ? 'noListMarker' : ''
                    }`}>
                    {isEbonFaq ? (
                        <p>{convertHtmlToReactDomWithParams(removeListMarker(faq.content))}</p>
                    ) : (
                        convertHtmlToReactDomWithParams(faq.answer)
                    )}
                </div>
            </div>
        );
    };

    renderOnConditionnalSectionContents = () => {
        const { faq, linkToFaqPage } = this.props;
        if (linkToFaqPage) {
            return (
                <LocalizedNavLink to={`${PATH.FAQ_PATH}#${faq.id}`} key={faq.id}>
                    {this.renderSectionContents()}
                </LocalizedNavLink>
            );
        } else {
            return this.renderSectionContents();
        }
    };

    render() {
        const { faq } = this.props;
        return (
            <section className="faq-section" id={`${faq.id}`} ref={this.faqSection}>
                {this.renderOnConditionnalSectionContents()}
            </section>
        );
    }
}

FaqElementComponent.propTypes = {
    faq: PropTypes.object.isRequired,
    cssClass: PropTypes.string,
    forceArrowRight: PropTypes.bool,
    linkToFaqPage: PropTypes.bool,
    noListMarket: PropTypes.bool,
    isEbonFaq: PropTypes.bool
};

export default FaqElementComponent;



// WEBPACK FOOTER //
// ./src/components/pages/faq/FaqElementComponent.js